import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Movie } from '../../services/Page/page.service';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { RouterModule } from '@angular/router';
import { MatIconModule } from "@angular/material/icon";
import { BookingService } from '../../services/Booking/booking.service';
import { AddComponent } from "../UI/add/add.component";
import { gsap, Expo, Quad } from 'gsap';

@Component({
    selector: 'app-featured-card',
    imports: [
        CommonModule,
        SafeHtmlPipe,
        RouterModule,
        MatIconModule,
        AddComponent
    ],
    templateUrl: './featured-card.component.html',
    styleUrl: './featured-card.component.scss'
})
export class FeaturedCardComponent {
    @Input('movie') movie: Movie | undefined

    @ViewChild('videoRolloverEl') videoRolloverEl: ElementRef | undefined

    constructor(
        public bookingService: BookingService,
    ) {

    }

    onBookNow() {
        if (this.movie) {
            this.bookingService.open(this.movie)
        }
    }

    onOver() {
        if (this.movie?.videoBg && this.movie?.videoBg != '') {
            this.videoRolloverEl?.nativeElement.play()
            gsap.to(this.videoRolloverEl?.nativeElement, 3, {opacity: 1, ease: Expo.easeOut} );
        }
    }

    onOut() {
        if (this.movie?.videoBg && this.movie?.videoBg != '') {
            this.videoRolloverEl?.nativeElement.pause()
            gsap.to(this.videoRolloverEl?.nativeElement, 3, {opacity: 0, ease: Expo.easeOut} );
        }
    }
}
